import { RootState } from '@reducers/index';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';

export const getSuperAdminUsers = (state: RootState): Record<number, SuperAdminUser> =>
    state.superAdminUsersReducer.superAdminUsers;
export const getSuperAdminUser = (state: RootState, id: number): SuperAdminUser =>
    state.superAdminUsersReducer.superAdminUsers[id];

export const getSuperAdminUsersIsFetching = (state: RootState): boolean =>
    state.superAdminUsersReducer.isFetching;
export const getSuperAdminUsersError = (state: RootState): string | null =>
    state.superAdminUsersReducer.fetchError;
export const getSuperAdminUsersPostError = (state: RootState): string | null =>
    state.superAdminUsersReducer.postError;

export const getSuperAdminUserIsPosting = (state: RootState): boolean =>
    state.superAdminUsersReducer.isPosting;
export const getSuperAdminUserPostSuccess = (state: RootState): boolean =>
    state.superAdminUsersReducer.postSuccess;
